module.exports = "fragment MarketingParagraphFragment on MarketingParagraph {\n  __typename\n  createdAt\n  updatedAt\n  id\n  title\n  content\n}\n"